import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectPageState } from "../../features/reset/selectors";
import { PageState } from "../../features/reset/types";
import ResetExcutePage from "./ResetExcutePage";
import ResetRequest from "./ResetRequest";

const ResetPage: React.FC<{ completeTo: string }> = ({
  completeTo,
}): JSX.Element => {
  const state = useSelector(selectPageState);
  return getComponent(state, completeTo);
};

// 現在の再設定画面の状態に応じて表示Componentを出し分ける
const getComponent = (state: PageState, completeTo: string) => {
  switch (state) {
    case "sendMail":
      return <ResetRequest />;
    case "excute":
      return <ResetExcutePage />;
    case "complete":
      return <Navigate to={completeTo} replace />;
    default:
      return <div />;
  }
};

export default ResetPage;
